import * as React from "react";
import styled, { css } from "styled-components";

import { ANIMATION } from "../../consts/style";
import { ChevronRight } from "../Svg/ChevronRight";
import { splitLastWord } from "./utils";

export const Heading2 = styled.h2`
  margin: 0 0 16px 0;
  font-size: 32px;
  line-height: 1em;
  font-weight: 700;
  color: #232323;

  @media (min-width: 992px) {
    font-size: 40px;
  }
`;

export const Heading3 = styled.h3`
  margin: 0 0 16px 0;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 500;
  width: 100%;
  color: #232323;

  @media (min-width: 992px) {
    font-size: 32px;
  }
`;

export const Heading4 = styled.h4`
  margin-top: 0;
  line-height: 1.5;
  font-weight: 600;
  font-size: 16px;
  color: #232323;
`;

export const Byline = styled.p`
  font-size: 14px;
  line-height: 1.71;
  font-weight: normal;
  color: #505050;
` as any;

interface HeadingLinkProps {
  children?: React.ReactNode;
  inline?: boolean;
}

const ChevronHeading = styled(Heading4)`
  display: ${(p: HeadingLinkProps) => (p.inline ? "inline" : "block")};

  span {
    font: inherit;
  }
  svg {
    fill: #ff373c;
    height: 20px;
    transform: translate(${ANIMATION.CHEVRON.TRANSLATE_MIN});
    transition: transform ${ANIMATION.CHEVRON.SPEED};
  }
` as any;

/**
 * To animate the chevron, you will need to use the HeadingLink component, then
 * import the headingLinkOnHoverMixin and apply it to the styled component that
 * will be hovered. This way we can have the hover animation on the chevron in
 * css which means it will be available before downloading and parsing the JS
 * bundle.
 *
 * Example Usage:
 *
 * ```
 * styled.a`
 *   ${headingLinkOnHoverMixin};
 * `;
 * ```
 */
export const HeadingLink = ({
  children = "",
  inline = false,
}: HeadingLinkProps = {}) => {
  const [first, last] = splitLastWord(children);

  return (
    <ChevronHeading inline={inline}>
      <span>{first}</span>
      <span style={{ whiteSpace: "nowrap" }}>
        {last}
        <ChevronRight />
      </span>
    </ChevronHeading>
  );
};

export const headingLinkOnHoverMixin = css`
  /* stylelint-disable-next-line */
  &:hover ${ChevronHeading} svg {
    transform: translate(${ANIMATION.CHEVRON.TRANSLATE_MAX});
  }
`;
